/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */

import React, {  useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { useContext } from 'react';
import { Link } from 'react-router-dom';
import MonitorActivityExportFunction from '../../../ManageOrganizationUser/ManageUserExportHistory/Components/Export/Index';
import OrgViewMonitorExport from '../../MonitorUserTable/Export';
import { handleSidebarPrvState } from '../../../../../redux/systemConfigSlice';


const OrgPatientTopBar = ({
    title,
    path,
    pathPlaceholder,
    isColumnSelect,
    setIsColumnSelect,
    exportCols,
    username,
    isExport,
    data, exportMonitorExport,isFilterOrganization,SearchInput,handleSearchClose}) => {

    
    const {isSideBar,setIsSideBar,setIsAdvancedSearchOpen,isAdvancedSearchOpen} = useContext(GlobalContext);
    const dispatch=useDispatch()
    
    // Function to handle onClick logic
    const handleSearchClick = () => {  
        // Store the current isSideBar state in Redux
        dispatch(handleSidebarPrvState(isSideBar));
          
        // Update the states after storing the previous state
        setIsAdvancedSearchOpen(true);
        setIsSideBar(false);
    };
  
    return (
        <div className="flex justify-between items-center mb-[14px] w-full">
        
            {title!==undefined ?
                <h1 className="text-xl font-normal text-[#000000] min-w-fit">{title}</h1>
                :
                pathPlaceholder &&
                    <Link to={path} state={username ? [username] : null} onClick={()=>handleSearchClose()} className=' items-center min-w-max flex'>
                        <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                        <span className='text-sm font-normal text-[#008586] pl-3'>{pathPlaceholder}</span>
                    </Link>
            }
            <h1 className={`text-xl font-normal text-[#000000] text-center ${data!==undefined&&data?.data?.length>0 ? "xl:ml-[-140px]":"xl:ml-[-180px] ml-[-122px]"}`}>
                List of Patients
            </h1>
            <div className="relative">
                {SearchInput && <button id='search-btn' onClick={handleSearchClick} className="ml-2.5 border border-[#972E4C] rounded-[15px] px-[13px] py-[13px]">
                    <img loading='lazy' decoding='async' src="/images/search_red.svg" alt="icon" className=''/>
                </button>}
                {(isExport&&data?.data?.length>0)&&  <OrgViewMonitorExport
                    exportMonitorExport={exportMonitorExport}
                    exportCols={exportCols}
                    isColumnSelect={isColumnSelect}
                    setIsColumnSelect={setIsColumnSelect}
                    isPatientExp={true}
                />}
            </div>
        </div>
    );
}

export default OrgPatientTopBar;
